import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './messagesDialog.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import CloseIcon from '@/assets/steam/close.svg'
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import 'react-phone-input-2/lib/style.css';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUpdateContact } from '../api/updateContact';
import { ModalFooter } from 'react-bootstrap';
import { useDeleteCity } from '../api/deleteCity';
import { Contact } from '../types/indes';
import { SelectedManagers } from '@/features/users/components/SelectedManagers';
import { showNotification } from '@/utils/notificationUtils';
import { useGetMessage } from '../api/getMessages';
import Utils from '@/utils/util';
import HiIcon from '@/assets/img/message-hi.png';
import Usericon from '@/assets/steam/user-grey.png';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSendMessage } from '../api/sendMessage';

const ViewMessage: VFC<{
  onConfirm: () => void;
  onClose: () => void;
  open: boolean;
  selectedContact?: any;
  onRemoveUser: (data: any) => void;
}> = ({ onClose, onConfirm, open, selectedContact, }) => {
  const { user } = useAuth();
  const [selectedContactList, setSelectedConatctList] = useState<Contact[]>([]);
  const useGetMessageMutation = useGetMessage();
  const [messages, setMessages] = useState<any>('');
  const [messageForSending, setMessageForSending] = useState<any>('')
  const useSendMessageMutation = useSendMessage();


  useEffect(() => {
    if (selectedContact) {
      getMessages();

    }

  }, [selectedContact])
  const resetStates = () => {
    setMessages('')
    setSelectedConatctList([]);
  }

  const getMessages = async () => {
    const res = await useGetMessageMutation.mutateAsync({
      phone: selectedContact.phone
    });
    if (res) {
      setMessageForSending('');
      setMessages(res ? res : '');
    }
  }

  const onScrollEndEvent = () => {
    // getMessageDetails(tableCurrentIndex + 1);
    //getMessages();
  };

  const getContent = () => {
    return (
      <div className="view-messages-content">
        <div className="message-details-card">
          <div className="message-top-header">
            <div className="message-pet-div">
            </div>
          </div>

          <div className="messaging-details">


            <div
              id="scrollableDiv"
              style={{
                height: `calc(100% - 0px)`,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column-reverse',
                paddingRight: '15px',
                paddingBottom: '0px',
              }}
            >

              {!messages?.messages && <div className='no-messages'>No messages
              </div>}
              {messages && messages?.messages && messages?.messages?.items && messages?.messages?.items.length > 0 && <InfiniteScroll
                dataLength={messages && messages?.messages && messages?.messages?.items && messages?.messages?.items.length}
                next={onScrollEndEvent}
                hasMore={true}
                inverse={true}
                style={{ display: 'flex', flexDirection: 'column-reverse' }}
                scrollableTarget="scrollableDiv"
                loader={false}
              >
                {messages?.messages?.items.map((message: any) => {

                  if (message?.finalText) {
                    //console.log("DEFAULTTTT", message)
                    return (
                      <div className="user-message-detail-card is-my-message">
                        <div className="users-ful-message">

                          <div className="user-message-name isme"> <img src={Usericon} /> {'You'}</div>
                          <span className="message-view is-my-message">{message?.finalText}</span>
                          <div className="messgae-details is-my-message">
                            {message?.messageSource === 'SMS' && <div className="messaging-date-point">.</div>}{' '}
                            <div className="messaging-date">
                              {message?.created ? Utils.formatOnlyDay(message?.created) : ''}{' '}
                              {message?.created ? Utils.convertTimestampToTimeFormat(message?.created) : ''}
                            </div>
                          </div>
                        </div>
                      </div>

                    )
                  } else if (message?.owner === false) {
                    console.log("owner false", message)
                    return (
                      <div className="user-message-detail-card">
                        <div className="users-ful-message">
                          <div className="user-message-name "> <img src={Usericon} /> {selectedContact?.name}</div>
                          <span className="message-view ">{message?.text}</span>
                          <div className="messgae-details">
                            {message?.messageSource === 'SMS' && <div className="messaging-date-point">You.</div>}{' '}
                            <div className="messaging-date">
                              {message?.created ? Utils.formatOnlyDay(message?.created) : ''}{' '}
                              {message?.created ? Utils.convertTimestampToTimeFormat(message?.created) : ''}
                            </div>
                          </div>
                        </div>
                      </div>

                    )
                  }
                  else if (message?.owner === true) {
                    console.log("owner true", message)
                    return (
                      <div className="user-message-detail-card is-my-message">
                        <div className="users-ful-message">
                          <div className="user-message-name isme"> <img src={Usericon} /> {message?.operatorName}</div>
                          <span className="message-view is-my-message">{message?.text}</span>
                          <div className="messgae-details is-my-message">
                            {message?.messageSource === 'SMS' && <div className="messaging-date-point">.</div>}{' '}
                            <div className="messaging-date">
                              {message?.created ? Utils.formatOnlyDay(message?.created) : ''}{' '}
                              {message?.created ? Utils.convertTimestampToTimeFormat(message?.created) : ''}
                            </div>
                          </div>
                        </div>
                      </div>

                    )
                  }

                })}
              </InfiniteScroll>}
            </div>
            {/* <span ref={scrollAnchor} /> */}
          </div>
        </div>



      </div>
    );
  };

  const validate = () => {
    let errorMessage = '';
    if (!messageForSending
    ) {
      errorMessage = 'Please enter message';
    }
    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'name') {
      setMessageForSending(event.target.value);
    }
  };

  return (
    <>
      <Modal
        show={open}
        onHide={() => { resetStates(), onClose() }}
        className={`steam-modal-dialog view-message-modal `}
        size="sm"

      >
        <Modal.Header closeButton >
          <div className="model-header-tab">
            <div className="message-top-header">
              <div className="message-name-div">
                <div className="message-name">{selectedContact?.name}</div>
                <div className="message-email">{selectedContact?.email} | {`${selectedContact?.phone}`}</div>
              </div>

            </div>
          </div>
        </Modal.Header>
        <Modal.Body >{getContent()}</Modal.Body>
        <ModalFooter>
          <div className='send-messsage-footer'>
            <div className='mt-footer'>


              <div className='send-msg'>
                <input
                  className={`custome-input width-50`}
                  placeholder={'Enter message...'}
                  onChange={handleChange}
                  value={messageForSending}
                  id="name"
                />
              </div>
              <div className={`btn-container end`}>
                <button
                  className={`steam-button button-dark set-height`}
                  onClick={async () => {
                    if (validate()) {

                      // const filterNumbers = [selectedContact?.phone];
                      const filterNumbers = [
                        selectedContact?.phone?.startsWith("+91")
                          ? selectedContact.phone.substring(3)
                          : selectedContact?.phone
                      ];
                      await useSendMessageMutation.mutateAsync({
                        contacts: filterNumbers ? filterNumbers : [],
                        message: messageForSending,
                        isSingleMessage: true,
                      });
                      setTimeout(() => {
                        getMessages();
                      }, 5000)

                    }

                  }}
                  disabled={useSendMessageMutation?.isLoading}
                >
                  <span>{'Send'}</span>
                </button>
              </div>
            </div>
          </div>

        </ModalFooter>
      </Modal>
    </>
  );
};




export default ViewMessage;
